<script lang='ts'>
    import { onMount } from "svelte"
    import { slide } from 'svelte/transition'

    export let alwaysOpen = false
    export let startClosed = true
    let className: string = ""
    export {className as class}

    let isClosed = true
    onMount(() => {
        isClosed = startClosed && !alwaysOpen
    })
    const toggle = () => {
        isClosed = !isClosed
    }

    // TODO: Replace with shadcn Accordion.
</script>

<div class={className}>

    <div data-state={isClosed ? "closed" : "open"} role="button" tabindex="0" class:pointer-events-none={alwaysOpen} class="group flex gap-2 hover:cursor-pointer items-center justify-between py-2 accordion-trigger transition-all" on:click={toggle} on:keydown={()=>{}}>
        <div class="group-hover:underline w-full">
            {#if alwaysOpen}
                <h4>
                    <slot name='trigger'/>
                </h4>
            {:else}
                <slot name='trigger'/>
            {/if}
        </div>
        {#if !alwaysOpen}
            <i class='fa-light fa-chevron-down text-xs transition-transform duration-200'/>
        {/if}
    </div>

    {#if !isClosed}
    <div transition:slide>
        <!-- Extra wrapper required to prevent jump on slide transition -->
        <div class="pb-2 pt-0">
		    <slot name="content" />
        </div>
	</div>
    {/if}

</div>

<style lang='scss'>

    .accordion-trigger {
        &[data-state=open] > i {
            transform: rotate(180deg)
        }
    }
    
</style>